import clsx from 'clsx';
import Image from 'next/image';
import type { ImageType } from '../../types.d/storeTypes';
import styles from './BlogArticleTextImage.module.scss';

export type BlogArticleTextImageProps = {
  title: string;
  content: string;
  image: ImageType;
};

/**
 * Blog Article Text & Image Component
 *
 * @param props - BlogArticleTextImageProps
 */
export const BlogArticleTextImage = ({
  title,
  content,
  image,
}: BlogArticleTextImageProps) => {
  if (!image || !content || !title) return <></>;

  return (
    <section className={clsx(styles.blogArticleTextImage, 'grid')}>
      {image?.url && (
        <div className={clsx('col xs4 l1-4', styles.blogArticleTextImage__img)}>
          <Image
            height={image.height}
            width={image.width}
            src={image.url}
            alt={image.title}
            title={image.title}
          />
        </div>
      )}
      <div
        className={clsx(
          styles.blogArticleTextImage__copy,
          image?.url ? 'col xs4 l5-12 hasImage' : 'col xs4 l1-12'
        )}
      >
        <h2
          className={clsx(
            styles.blogArticleTextImage__title,
            'text-blog-heading-h2-mobile text-blog-heading-h2-desktop'
          )}
        >
          {title}
        </h2>
        <div
          className={clsx(
            styles.blogArticleTextImage__content,
            'text-blog-body-mobile text-body-1-desktop'
          )}
        >
          {content}
        </div>
      </div>
    </section>
  );
};
